enum PosSoftwareCustomerOnboardingStateEnum {
  Registered = "Registered",
  Onboarded = "Onboarded",
}

export default PosSoftwareCustomerOnboardingStateEnum;
